;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import { graphRequest } from 'services/contentful';

import {
    assetFragment,
    ctaFragment,
    linkFragment,
} from 'lib/graphql/fragments';

import BlockCategoryDetailIntro from './BlockCategoryDetailIntro';

const query = /* GraphQL */ `
    ${assetFragment}
    ${ctaFragment}
    ${linkFragment}
    query getBlock($id: String!, $preview: Boolean!) {
        blockCategoryDetailIntro(preview: $preview, id: $id) {
            __typename
            anchorId
            headline {
                json
            }
            imageDesktop {
                ...Asset
            }
            imageMobile {
                ...Asset
            }
            primaryCta {
                ...CTA
            }
            secondaryCta {
                ...CTA
            }
            backgroundColor
            floorColor
        }
    }
`;

async function fetchBlock(id) {
    const {
        body: {
            data: { blockCategoryDetailIntro },
        },
    } = await graphRequest({
        query,
        variables: { id },
    });

    return blockCategoryDetailIntro;
}

const BlockCategoryDetailIntroServer = async ({ id }) => {
    const block = await fetchBlock(id);

    return <BlockCategoryDetailIntro {...block} />;
};

export default BlockCategoryDetailIntroServer;
